<template>
  <div>
    <b-card no-body>
      <b-card-body class="d-flex justify-content-between align-items-center">
        <div class="truncate">
          <h2 v-if="title" class="mb-25 font-weight-bolder">
            {{ title }}
          </h2>
          <span>{{ message }}</span>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue';

export default {
  components: {
    BCard,
    BCardBody
  },
  props: {
    message: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  }
};
</script>

<style>
.error-color {
  color: #cc0000;
}
</style>
